import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataProductGroup } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_PRODUCT_GROUP =
  defineMasterdataEntity<MasterdataProductGroup>({
    name: 'product-group',
    responseKey: 'productGroups',
    displayWith: (g) => keyName(g.key, g.name),
    defaultFilter: ACTIVE_ONLY,
    icon: 'fa-regular fa-layer-group',
    title: 'Produktgruppensuche',
    label: 'Produktgruppe',
    placeholder: 'Produktgruppe suchen...',
    columns: [
      {
        label: 'Produktgruppe',
        type: 'entity',
        icon: 'fa-regular fa-layer-group',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Nr.', type: 'text', value: (e) => e.key },
      { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
      { label: 'Aktiv', type: 'text', value: (e) => (e.active ? 'Ja' : 'Nein') },
    ],
  });
